<template>
  <el-dialog
    :visible="true"
    :before-close="handleClose"
    :title="$t('报警阈值设置')"
    width="700px"
    class="alarm-threshold-settings-611"
    top="10vh"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
    element-loading-text="Loading"
  >
    <div class="alarm-threshold-settings-611_content scrollbar-thin">
      <MForm v-bind="form">
        <template #params="{ model, config }">
          <MForm :config="config.cfg" :model="model" />
        </template>
      </MForm>
    </div>

    <div class="action-wrap">
      <el-button @click="reset" :loading="loading">{{ $t('刷新') }}</el-button>
      <el-button type="primary" @click="save" :loading="saveLoading">{{ $t('保存') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MForm from '@/components/form/index.vue';

import { awaitTo } from '@/utils/utils';
import { baseInfoHandler, makeThresholdCols } from './util';
import {
  get611DeviceAlarmThresholdInfo,
  set611DeviceAlarmThresholdInfo
} from '@/api/deviceSetting';
import { getSensorList } from '@/api/devices';
import { isEmpty, isObject } from '@/utils/is';

export default {
  components: {
    MForm
  },
  props: {
    sn: {
      type: String,
      default: ''
    },
    container: {
      type: HTMLElement,
      default: () => document.body
    }
  },
  data() {
    return {
      i18nPath: 'part',
      loading: false,
      saveLoading: false,
      form: {
        i18nPath: 'threshold',
        config: {
          labelWidth: 'auto',
          span: 24,
          options: [
            {
              span: 14,
              type: 'select',
              prop: 'sensorSeq',
              dataKey: 'sensors',
              label: '传感器名称'
            },
            {
              span: 14,
              type: 'select',
              prop: 'unit',
              dataKey: 'unitList',
              disabled: true,
              label: '单位'
            },
            {
              span: 15,
              type: 'custom',
              slot: 'params',
              prop: 'currentParam',
              cfg: {
                labelWidth: 'auto',
                span: 24,
                options: makeThresholdCols(false)
              },
              label: '报警阈值'
            },
            {
              span: 15,
              type: 'custom',
              slot: 'params',
              disabled: true,
              prop: 'default1Param',
              cfg: {
                labelWidth: 'auto',
                span: 24,
                options: makeThresholdCols(true)
              },
              label: '默认报警阈值(工作场景)'
            },
            {
              span: 15,
              type: 'custom',
              slot: 'params',
              disabled: true,
              prop: 'default2Param',
              cfg: {
                labelWidth: 'auto',
                span: 24,
                options: makeThresholdCols(true)
              },
              label: '默认报警阈值(公共场景)'
            }
          ]
        },
        model: {
          sensorSeq: '',
          unit: '',
          currentParam: {},
          default1Param: {},
          default2Param: {}
        },
        dataSource: {
          sensors: [],
          unitList: ['PPM', 'vol%', 'LEL%', 'mg/m³', 'PPB'].map((e, i) => ({ label: e, value: i }))
        },
        rules: {}
      }
    };
  },
  methods: {
    handleClose(done) {
      this.$destroy();
      done?.();
    },
    async getThresold() {
      if (isEmpty(this.form.model.sensorSeq)) return;

      this.loading = true;

      const [err, res] = await awaitTo(
        get611DeviceAlarmThresholdInfo({ sn: this.sn, sensorSeq: this.form.model.sensorSeq })
      );

      this.loading = false;

      if (err) {
        return console.log(err);
      }

      const data = baseInfoHandler(res);

      if (data.sensorSeq != this.form.model.sensorSeq) return;

      Object.assign(this.form.model, {
        unit: data.unit,
        currentParam: data.currentParam,
        default1Param: data.default1Param,
        default2Param: data.default2Param
      });
    },
    async initSensorList() {
      this.loading = true;

      const [err, res] = await awaitTo(getSensorList(this.sn));

      this.loading = false;

      if (err) {
        console.log(err);
        return;
      }

      if (isObject(res?.data) && !isEmpty(res?.data)) {
        this.form.dataSource.sensors = Object.keys(res.data).map(key => ({
          label: res.data[key],
          value: +key
        }));

        this.form.model.sensorSeq = +Object.keys(res.data)[0];
      }
    },
    reset() {
      this.getThresold();
    },
    async save() {
      this.saveLoading = true;

      const [err, _res] = await awaitTo(
        set611DeviceAlarmThresholdInfo({
          sn: this.sn,
          deviceType: this.deviceType,
          requestData: {
            sensorSeq: this.form.model.sensorSeq,
            currentParam: this.form.model.currentParam,
            default1Param: this.form.model.default1Param,
            default2Param: this.form.model.default2Param
          }
        })
      );

      this.saveLoading = false;

      if (err) {
        this.$message({
          type: 'error',
          message: this.$t('保存失败')
        });
        return;
      }

      this.$message({
        type: 'success',
        message: this.$t('保存成功')
      });
    }
  },
  watch: {
    'form.model.sensorSeq'() {
      this.getThresold();
    }
  },
  mounted() {
    document.body.appendChild(this.$el);

    this.initSensorList();
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.alarm-threshold-settings-611 {
  box-sizing: border-box;

  &_content {
    height: calc(100% - 55px);
    overflow-y: auto;
    overflow-x: hidden;
  }

  .el-dialog {
    height: calc(100vh - 20vh);

    max-width: 85vw;

    &__body {
      height: calc(100% - 55px);
      box-sizing: border-box;
    }

    .action-wrap {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
